import { render, staticRenderFns } from "./LongText.vue?vue&type=template&id=53fe7c5d&scoped=true"
import script from "./LongText.vue?vue&type=script&lang=js"
export * from "./LongText.vue?vue&type=script&lang=js"
import style0 from "./LongText.vue?vue&type=style&index=0&id=53fe7c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe7c5d",
  null
  
)

export default component.exports